import select from './selectors';

class Validators {
  constructor(state) {
    this._selector = select(state);
  }

  isPaymentVerified() {
    return !!this._selector.getPayment().verified;
  }

  isPaymentValid() {
    function validateParam(obj, param) {
      return obj[param] !== null;
    }

    const payment = this._selector.getPayment();
    const shop = this._selector.getShop();

    const toValidate = [
      [payment, 'amount'],
      [payment, 'sign'],
      [payment, 'shopOrderId'],
      [payment.currency, 'id'],
      [shop, 'id'],
    ];

    return !toValidate.find(([obj, param]) => !validateParam(obj, param));
  }

  payWayPresentInPayment() {
    const { payWay } = this._selector.getPayment();

    return payWay != null && payWay !== '';
  }

  cache(type, ...args) {
    let timeout;

    try {
      timeout = this._selector.getCacheTimeout(type, ...args);
    } catch (e) {
      return false;
    }

    return timeout > Date.now();
  }

  invoiceCreated() {
    return this._selector.getInvoice().url !== null;
  }
}

export default function validate(state) {
  return new Validators(state);
}
